/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which unit systems are supported?`)
};

const es_uc_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué sistemas de unidades son compatibles?`)
};

const de_uc_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Einheitensysteme werden unterstützt?`)
};

const nl_uc_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke eenhedenstelsels worden ondersteund?`)
};

const fr_uc_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels systèmes d'unités sont supportés ?`)
};

const it_uc_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali sistemi di unità sono supportati?`)
};

const pt_br2_uc_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais sistemas de unidades são suportados?`)
};

const pt_uc_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais são os sistemas de unidades suportados?`)
};

const ja_uc_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの単位系がサポートされていますか?`)
};

const zh_uc_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_faq3_q", locale)
	if (locale === "en") return en_uc_hub_faq3_q(inputs)
	if (locale === "es") return es_uc_hub_faq3_q(inputs)
	if (locale === "de") return de_uc_hub_faq3_q(inputs)
	if (locale === "nl") return nl_uc_hub_faq3_q(inputs)
	if (locale === "fr") return fr_uc_hub_faq3_q(inputs)
	if (locale === "it") return it_uc_hub_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_faq3_q(inputs)
	if (locale === "pt") return pt_uc_hub_faq3_q(inputs)
	if (locale === "ja") return ja_uc_hub_faq3_q(inputs)
	return zh_uc_hub_faq3_q(inputs)
};